module.exports = __webpack_public_path__ + "static/cullector-logo-eab1ef9b22cd71815296e86f5bac9094.png";